module.exports = __webpack_public_path__ + "img/keyword-search-monitoring.6bb896be.png";